import { CircularProgress } from "@mui/material";
import { toDecimalString } from "../../common/strings";
import LearningHistory from "../model/LearningHistory";
import styles from "../css/LearningHistoryCell.module.css";
import { getLearningRangeText } from "../util/learning";
import { LearningHistoryRange } from "../model/learningHistoryRange";
import Spinner from "../../../components/ui/Spinner";
import CorrectOrIncorrectTermsCountView from "../../common/view/CorrectOrIncorrectTermsCountView";
import { LearningAnswerType } from "../model/LearningAnswerType";

interface LearningHistoryCellProps {
  learningHistory: LearningHistory;
  learningHistoryRange: LearningHistoryRange;
  handleOnClick: (item: LearningHistory) => void;
}

export default function LearningHistoryCell(props: LearningHistoryCellProps) {
  const title = getLearningRangeText(props.learningHistoryRange);

  const totalLearnedTermsCount =
    props.learningHistory.correctTermsCount +
    props.learningHistory.incorrectTermsCount;

  const correctRatio =
    (props.learningHistory.correctTermsCount / totalLearnedTermsCount) * 100;
  const safeCorrectRatio = isNaN(correctRatio) ? 0 : Math.round(correctRatio);

  function hasLearnedTerms(): boolean {
    return (
      props.learningHistory.incorrectTermsCount !== 0 ||
      props.learningHistory.correctTermsCount !== 0
    );
  }

  return (
    <>
      {props.learningHistory.correctTermsCount < 0 && (
        <div className={styles.loadingContainer}>
          <Spinner size={24} />
        </div>
      )}
      {props.learningHistory.correctTermsCount >= 0 && (
        <button
          type="button"
          className={styles.container}
          onClick={() => {
            props.handleOnClick(props.learningHistory);
          }}
        >
          <div className={styles.leftContainer}>
            <div className={styles.contentContainer}>
              <span className={styles.titleText}>{title}</span>
              <span className={styles.termsLearnedCountValueText}>
                {toDecimalString(totalLearnedTermsCount)}
              </span>
            </div>

            <div className={styles.correctAndIncorrectContainer}>
              <CorrectOrIncorrectTermsCountView
                showing={!hasLearnedTerms()}
                type={undefined}
                termsCount={0}
              />
              <CorrectOrIncorrectTermsCountView
                showing={hasLearnedTerms()}
                type={LearningAnswerType.correct}
                termsCount={props.learningHistory.correctTermsCount}
              />
              <CorrectOrIncorrectTermsCountView
                showing={hasLearnedTerms()}
                type={LearningAnswerType.incorrect}
                termsCount={props.learningHistory.incorrectTermsCount}
              />
            </div>
          </div>
          <div className={styles.rightContainer}>
            <CircularProgress
              variant="determinate"
              sx={{
                color: "var(--color-primary)",
              }}
              size={48}
              thickness={4}
              value={safeCorrectRatio}
            />
            <span className={styles.percentageText}>
              {safeCorrectRatio + "%"}
            </span>
          </div>
        </button>
      )}
    </>
  );
}
